import reportList from '../pages/dnaReport/application.vue';
import reportSetting from '../pages/dnaReport/report-setting.vue';
import reportSingle from '../pages/dnaReport/single-application.vue';

const routes = [
  { // /dna-report
    path: '/dna-report',
    redirect: '/dna-report/application'
  },
  { // /dna-report/application
    path: '/dna-report/application',
    name: 'dna-report-application',
    component: reportList,
    meta:{
      name: 'Applications',
      requireAuth: true
    },
  },
  { // /dna-report/report
    path: '/dna-report/report',
    name: 'dna-report-report',
    component: reportSetting,
    meta:{
      name: 'Report Setting',
      requireAuth: true
    },
  },
  { // /dna-report/application/:id
    path: '/dna-report/application/:id',
    name: 'dna-report-single-application',
    component: reportSingle,
    meta:{
      name: 'Report',
      requireAuth: true
    },
    props: true
  },
]

export default routes